"use client"
 
import { LeaveRequestApprovalsPage } from "../../modules/leave-management/leave-request-approvals"
import { Card } from "../../ui/card"

interface LeaveRequestApprovalsProps {
  sidebarOpen?: boolean
}

export default function LeaveRequestApprovals({sidebarOpen }: LeaveRequestApprovalsProps) {
  return (
    <div className="p-4 sm:p-6 space-y-6 text-gray-900 bg-gray-50">
      <Card className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <LeaveRequestApprovalsPage />
      </Card>
    </div>
  )
}

